import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import Table from './Table'
import Pagination from '../Pagination'
import AuthContext from 'context/AuthContext'
import dayjs from 'dayjs'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

function User () {
  const { t } = useTranslation()
  const location = useLocation()
  const { logoutUser, user, updatePageName } = useContext(AuthContext)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [addShowModal, setShowModal] = useState(false)
  const [editShowModal, setEditShowModal] = useState(false)
  const [viewShowModal, setViewShowModal] = useState(false)
  const [users, setAllUser] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [item, setItem] = useState('')
  const [isDelete, setIsDelete] = useState(false)
  const [verificationStatusFilter, setVerificationStatusFilter] = useState(location?.state?.verified)
  const [occupation, setOccupationFilter] = useState(location?.state?.occupations)
  const [filterData, setFilterData] = useState({category:'',searchkey:'',startDate:location?.state?.startDate,endDate:location?.state?.endDate,isReset:false, isFilter:false})
  const [sort, setSort] = useState({
    sort_key: 'createdAt',
    sort_type: 'desc'
  })
  const manager = user?.permission?.find(e => e.manager === 'customers') ?? {}
  // get all user function-
  const getAllUser = async (data) => {
    try {
      const {category, startDate, endDate, searchkey, isFilter} = filterData
      if ((data?.deletePage && !(users?.length > 1) || (isFilter && category && data?.statusChange && !(users?.length > 1))) ) {
        if (!(users?.length > 1)) {
          setPage(page - 1)
          setIsDelete(true)
          setFilterData({...filterData, category:''})
          setPaginationObj({ ...paginationObj, page: page - 1 })
        }
      }
      else {
        setIsDelete(false)
      }
      const payload = {
        page,
        pageSize,
        status: category === 'all' ? '' : category,
        start_date: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
        end_date: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null,
        keyword: searchkey?.trim(),
        sort_key: sort.sort_key,
        sort_type: sort.sort_type,
        verified: verificationStatusFilter,
        occupations: occupation
      }

      const path = apiPath.getUsers
      const result = await apiGet(path, payload)
      if (result?.status === 200) {
        const response = result?.data?.results
        const resultStatus = result?.data?.success
        setAllUser(response?.docs)
        setPaginationObj({
          ...paginationObj,
          page: resultStatus ? response.page : null,
          pageCount: resultStatus ? response.totalPages : null,
          perPageItem: resultStatus ? response?.docs.length : null,
          totalItems: resultStatus ? response.totalDocs : null
        })
      }
    } catch (error) {
      console.log('error ', error)
      setPaginationObj({})
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }

  const handlePageClick = (event) => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const handelEdit = (item) => {
    setItem(item)
    setEditShowModal(true)
  }

  const handleUserView = (item) => {
    setItem(item)
    setViewShowModal(true)
  }

  const handleSearchKey = (e) => {
    setFilterData({...filterData, searchkey:e.target.value, isFilter:true})
    setPage(1)
  }

  const handleReset = () => {
    setOccupationFilter('')
    setVerificationStatusFilter('')
    setFilterData({category:'',searchkey:'',startDate:'',endDate:'',isReset:true, isFilter:false})
    setPage(1)
    setIsDelete(true)
  }

  const handleDateChange = (start, end) => {
    setPage(1)
    setFilterData({...filterData, startDate:start, endDate:end, isFilter:true})
    setIsDelete(true)
  }

  const statusPage = (e) =>{
    setFilterData({...filterData, category: e.target.value, isFilter:true})
    setPage(1)
    setIsDelete(true)
  }

  const verificationStatusPage = (e) =>{
    setVerificationStatusFilter(e.target.value)
    setPage(1)
    setIsDelete(true)
  }

  useEffect(() => {
    updatePageName(t("O_USERS"))
    getAllUser()
  }, [page, filterData, sort, verificationStatusFilter])

  return (
    <div>
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <form   className='border-b border-b-[#E3E3E3] grid md:grid-cols-3 px-4 py-3 pt-5 align-top'>
              <div className='flex flex-wrap  items-center col-span-2'>
                <div className='flex items-center lg:pt-0 pt-3 flex-wrap justify-start'>
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    isReset={filterData?.isReset}
                    setIsReset={setFilterData}
                    startDate={location.state?.startDate}
                    endDate={location.state?.endDate}
                  />
                  <div className='flex items-center mb-3 ml-3'>
                    <select
                      id='status'
                      type=' password'
                      name='status'
                      className='block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                      placeholder=' '
                      value={filterData?.category}
                      onChange={(e)=>statusPage(e)}
                    >
                      <option defaultValue value=''>
                        {t('O_STATUS')}
                      </option>
                      {/* <option value='all'>
                        {t('O_ALL')}
                      </option> */}
                      <option value='active'>{t('O_ACTIVE')}</option>
                      <option value='inactive'>{t('O_INACTIVE')}</option>
                    </select>
                  </div>
                  <div className='flex items-center mb-3 ml-3'>
                    <select
                      id='verification'
                      type=' password'
                      name='verification'
                      className='block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                      placeholder=' '
                      value={verificationStatusFilter}
                      onChange={(e)=>verificationStatusPage(e)}
                    >
                    <option defaultValue value=''>
                        {t('O_VERIFICATION')}
                      </option>
                      {/* <option value='all'>
                        {t('O_ALL')}
                      </option> */}
                      <option value='verified'>{t('O_VERIFIED')}</option>
                      <option value='notVerified'>{t('O_UNVERIFIED')}</option>
                      <option value='pending'>{t('O_REQUESTED')}</option>
                    </select>
                  </div>
                  <button
                    type='button'
                    onClick={handleReset}
                    className='bg-LightBlue text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2'
                  >
                    {t('O_RESET')}
                  </button>
                </div>
              </div>
              <div className='flex items-start pt-2 md:justify-end px-4'>
                <label
                  htmlFor='default-search'
                  className='mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white'
                >
                  {t('O_SEARCH')}
                </label>
                <div className='flex'>
                  <div className='relative '>
                    <div className='absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none'>
                      {!filterData?.searchkey && (
                        <svg
                          aria-hidden='true'
                          className='w-4 h-4 text-[#A5A5A5] dark:text-gray-40'
                          fill='none'
                          stroke='currentColor'
                          viewBox='0 0 24 24'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                          />
                        </svg>
                      )}
                    </div>
                    <input
                      type='search'
                      id='default-search'
                      className='block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[250px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      placeholder={t('O_SEARCH_BY_NAME')}
                      value={filterData?.searchkey}
                      title=''
                      required
                      onChange={(e) => handleSearchKey(e)}
                    />
                  </div>
                </div>
              </div>
            </form>
            <Table
              users={users}
              user={user}
              getAllUser={getAllUser}
              handelEdit={handelEdit}
              handleUserView={handleUserView}
              page={page}
              setSort={setSort}
              sort={sort}
              manager={manager}
            />
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                isDelete={isDelete}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}
export default User
